const ChevronoRightSvg = ({ onClick }) => {
    return (
        <svg onClick={onClick} role="button" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9229 9.41091C14.2484 9.73634 14.2484 10.264 13.9229 10.5894L8.08958 16.4228C7.76414 16.7482 7.23651 16.7482 6.91107 16.4228C6.58563 16.0973 6.58563 15.5697 6.91107 15.2442L12.1551 10.0002L6.91107 4.75609C6.58563 4.43065 6.58563 3.90301 6.91107 3.57757C7.23651 3.25214 7.76414 3.25214 8.08958 3.57757L13.9229 9.41091Z" fill="#6A7282" />
        </svg>

    )
}

export default ChevronoRightSvg